import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable()
export class RouteValidationService {
  constructor(private readonly router: Router) { }


  private readonly selected = new Subject<any>();
  title: string;

  selected$ = this.selected.asObservable();

  get() {
    return this.selected.next(this.title);
  }

  /**
   * This method compares the active Router url to the provided route parameter
   * Returns true if the router url contains the specified route; false otherwise
   * @param route - string containing the route url to be validated
   */
  isSelected(route, title: string = undefined): boolean {
    if (!this.router.url) return false;
    if (this.router.url === ('/' + route)) {
      this.title = title;
      this.selected.next(title);
      return true
    }


    return false;
  }

  isActiveRoute(route): boolean {
    return this.router.url &&
      this.router.url.indexOf('/' + route) !== -1;
  }
}
